import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import { isMobile } from "react-device-detect";
import Volume from "./Volume";
import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";
import SuperT20Rules from "./pop-up/supert20-rules";
import ball from "../../../assets/images/tpstudio/ball.svg";

import { setUserData } from "../../../store/userSlice";
import SuperOverT20Result from "./tp-result/SuperT20Result.jsx";

import { useDispatch, useSelector } from "react-redux";


const CARD_REVEAL_MS = 1000;

const parseBallList = (value) => {
  if (Array.isArray(value)) return value;
  if (value !== undefined && value !== null && value !== "") {
    return String(value)
      .split(/[,|]/)
      .map((s) => s.trim())
      .filter((s) => s !== "" && s !== "NOT AVAILABLE");
  }
  return [];
};

const getTeamCards = (p, team) => {
  if (!p) return [];
  const prefix = team === "a" ? "ac" : "bc";
  const cards = [];
  for (let i = 1; i <= 6; i++) {
    const val = p[`${prefix}${i}`];
    if (val && val !== "" && val !== "NOT AVAILABLE") {
      cards.push(val);
    }
  }
  if (cards.length) return cards;
  const cKey = team === "a" ? "c1" : "c2";
  return parseBallList(p[cKey]);
};

const buildSuperOverCardKey = (p) => {
  if (!p) return "";
  const parts = [];
  for (let i = 1; i <= 6; i++) {
    parts.push(p[`ac${i}`] ?? "");
    parts.push(p[`bc${i}`] ?? "");
  }
  parts.push(p.c1 ?? "", p.c2 ?? "");
  return parts.join("|");
};

const RANK_BY_CARD_INDEX = [
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "J",
  "Q",
  "K",
  "A"
];

/** Super Over T20: card rank → runs (see supert20-rules) */
const superOverRunFromRank = (rank) => {
  switch (String(rank).toUpperCase()) {
    case "A":
      return "1";
    case "2":
    case "3":
    case "4":
      return String(rank);
    case "6":
      return "6";
    case "10":
      return "0";
    case "K":
      return "W";
    default:
      return "0";
  }
};

const superOverRunFromCard = (cardId) => {
  if (cardId == null || cardId === "" || cardId === "NOT AVAILABLE")
    return null;
  const code = String(cardId).trim();
  if (code === "1") return null;

  if (/^[0-6]$/.test(code)) return code;
  if (/^W$/i.test(code)) return "W";

  if (/[a-zA-Z]/.test(code) && code.length >= 2) {
    return superOverRunFromRank(code.slice(0, -2));
  }

  const num = parseInt(code.replace(/\D/g, ""), 10);
  if (!Number.isNaN(num)) {
    return superOverRunFromRank(RANK_BY_CARD_INDEX[num % 13]);
  }

  return code;
};

const getTeamBallRuns = (p, team, revealCount) => {
  if (!p || revealCount <= 0) return [];
  const cards = getTeamCards(p, team);
  const revealed = cards.slice(0, revealCount);
  return revealed
    .map(superOverRunFromCard)
    .filter((r) => r != null && r !== "");
};

const sumBallRuns = (runs) =>
  runs.reduce((sum, run) => {
    const r = String(run).toUpperCase();
    if (r === "W") return sum;
    const n = parseInt(r, 10);
    return Number.isNaN(n) ? sum : sum + n;
  }, 0);

export default function SuperOverT20() {
  const dispatch = useDispatch();

  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [betButtonShow] = useState(true);
  const [betButtonShowLoaderShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [lastStatus, setLastStatus] = useState(null);

  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [b3Val, setB3Val] = useState(0);
  const [b4Val, setB4Val] = useState(0);
  const [b5Val, setB5Val] = useState(0);
  const [b6Val, setB6Val] = useState(0);
  const [l1Val, setL1Val] = useState(0);
  const [l2Val, setL2Val] = useState(0);
  const [l3Val, setL3Val] = useState(0);
  const [l4Val, setL4Val] = useState(0);
  const [l5Val, setL5Val] = useState(0);
  const [l6Val, setL6Val] = useState(0);

  const [teamABook, setTeamABook] = useState(0);
  const [teamBBook, setTeamBBook] = useState(0);
  const [wicketBook, setWicketBook] = useState(0);
  const [noWicketBook, setNoWicketBook] = useState(0);
  const [boundaryBook, setBoundaryBook] = useState(0);
  const [noBoundaryBook, setNoBoundaryBook] = useState(0);

  const [winnerA, setWinnerA] = useState(false);
  const [winnerB, setWinnerB] = useState(false);

  const [resultList, setResultList] = useState([]);
  const [roundId, setRoundId] = useState("");
  const [resultData, setResultData] = useState([]);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);
  const cardRevealTimers = useRef([]);
  const prevRoundRef = useRef(null);
  const prevCardKeyRef = useRef("");
  const revealCountARef = useRef(0);
  const revealCountBRef = useRef(0);
  const [revealCountA, setRevealCountA] = useState(0);
  const [revealCountB, setRevealCountB] = useState(0);
  const [cardsSettled, setCardsSettled] = useState(false);
  const cardsSettleTimerRef = useRef(null);

  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "superover_t20_virtual"
  });

  const payload = data?.data?.data;
  const wicketWinner =
    Number(payload?.team1WicketWinner) === 1;

  const noWicketWinner =
    Number(payload?.WicketNoWinner) === 1;

  const boundaryWinner =
    Number(payload?.team1BoundaryWinner) === 1;

  const noBoundaryWinner =
    Number(payload?.team1BoundaryNoWinner) === 1;

  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  console.log("payload:", data);
  const payloadResult = data?.data?.result;

  const pickPayloadBook = (index) => {
    if (!payload) return null;
    // Only read genuine exposure fields from the socket payload.
    // rnr${index}s is intentionally excluded: in this cricket game the payload
    // uses that key for ball-delivery scores, not per-user book values.
    const keys = [
      `cla${index}`,
      `book${index}`,
      `lib${index}`,
      `ubook${index}`
    ];
    for (let k = 0; k < keys.length; k++) {
      const v = payload[keys[k]];
      if (v !== undefined && v !== null && v !== "") {
        const n = Number(v);
        if (!Number.isNaN(n)) return n;
      }
    }
    return null;
  };

  const applyBooksFromPayload = () => {
    const b1 = pickPayloadBook(1);
    const b2 = pickPayloadBook(2);
    const b3 = pickPayloadBook(3);
    const b4 = pickPayloadBook(4);
    const b5 = pickPayloadBook(5);
    const b6 = pickPayloadBook(6);
    if (b1 != null) setTeamABook(b1);
    if (b2 != null) setTeamBBook(b2);
    if (b3 != null) setWicketBook(b3);
    if (b4 != null) setNoWicketBook(b4);
    if (b5 != null) setBoundaryBook(b5);
    if (b6 != null) setNoBoundaryBook(b6);
  };

  const resetCardReveal = () => {
    cardRevealTimers.current.forEach(clearTimeout);
    cardRevealTimers.current = [];
    revealCountARef.current = 0;
    revealCountBRef.current = 0;
    setRevealCountA(0);
    setRevealCountB(0);
    prevCardKeyRef.current = "";
    setCardsSettled(false);
    clearTimeout(cardsSettleTimerRef.current);
  };

  const queueCardReveals = (cardsA, cardsB) => {
    cardRevealTimers.current.forEach(clearTimeout);
    cardRevealTimers.current = [];

    let delay = 0;
    const startA = revealCountARef.current;
    const startB = revealCountBRef.current;
    const targetA = cardsA.length;
    const targetB = cardsB.length;

    for (let n = startA + 1; n <= targetA; n++) {
      const count = n;
      const t = setTimeout(() => {
        revealCountARef.current = count;
        setRevealCountA(count);
      }, delay);
      cardRevealTimers.current.push(t);
      delay += CARD_REVEAL_MS;
    }

    for (let n = startB + 1; n <= targetB; n++) {
      const count = n;
      const t = setTimeout(() => {
        revealCountBRef.current = count;
        setRevealCountB(count);
      }, delay);
      cardRevealTimers.current.push(t);
      delay += CARD_REVEAL_MS;
    }
  };

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  useEffect(() => {
    if (!payload) return;

    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setWinnerA(false);
      setWinnerB(false);
      setTeamABook(0);
      setTeamBBook(0);
      setWicketBook(0);
      setNoWicketBook(0);
      setBoundaryBook(0);
      setNoBoundaryBook(0);
      resetCardReveal();
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    setRoundId(payload?.cat_mid || "");
    setB1Val(payload?.b1 || 0);
    setB2Val(payload?.b2 || 0);
    setB3Val(payload?.b3 || 0);
    setB4Val(payload?.b4 || 0);
    setB5Val(payload?.b5 || 0);
    setB6Val(payload?.b6 || 0);
    setL1Val(payload?.l1 || 0);
    setL2Val(payload?.l2 || 0);
    setL3Val(payload?.l3 || 0);
    setL4Val(payload?.l4 || 0);
    setL5Val(payload?.l5 || 0);
    setL6Val(payload?.l6 || 0);

    if (payload?.result === 1) {
      setWinnerA(true);
      setWinnerB(false);
    } else if (payload?.result === 2) {
      setWinnerA(false);
      setWinnerB(true);
    }

    applyBooksFromPayload();

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;
    if (payloadResult !== "") {
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  // Reveal all team A cards one by one, then all team B cards one by one
  useEffect(() => {
    if (!payload) return;

    const currentRound = payload?.cat_mid;
    if (currentRound && currentRound !== prevRoundRef.current) {
      prevRoundRef.current = currentRound;
    }

    const cardsA = getTeamCards(payload, "a");
    const cardsB = getTeamCards(payload, "b");
    const cardKey = buildSuperOverCardKey(payload);

    if (!cardsA.length && !cardsB.length) return;
    if (cardKey === prevCardKeyRef.current) return;

    prevCardKeyRef.current = cardKey;
    queueCardReveals(cardsA, cardsB);
  }, [
    payload?.cat_mid,
    payload?.ac1,
    payload?.ac2,
    payload?.ac3,
    payload?.ac4,
    payload?.ac5,
    payload?.ac6,
    payload?.bc1,
    payload?.bc2,
    payload?.bc3,
    payload?.bc4,
    payload?.bc5,
    payload?.bc6,
    payload?.c1,
    payload?.c2
  ]);

  useEffect(
    () => () => {
      cardRevealTimers.current.forEach(clearTimeout);
      clearTimeout(cardsSettleTimerRef.current);
    },
    []
  );

  useEffect(() => {
    if (!payload) return;

    const cardsA = getTeamCards(payload, "a");
    const cardsB = getTeamCards(payload, "b");
    const allRevealed =
      cardsA.length + cardsB.length > 0 &&
      revealCountA >= cardsA.length &&
      revealCountB >= cardsB.length;

    if (!allRevealed) {
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    clearTimeout(cardsSettleTimerRef.current);
    cardsSettleTimerRef.current = setTimeout(() => {
      setCardsSettled(true);
    }, 1000);

    return () => clearTimeout(cardsSettleTimerRef.current);
  }, [payload, revealCountA, revealCountB]);

  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketType,
    sid
  ) => {
    const obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: 1,
      game_type: 7,
      game_name: "superover_t20_virtual",
      market_type: marketType,
      sid
    };
    setPlaceBetObject(obj);
    if (isMobile) setShowBetSlipPopup(true);
    else setShowBetSlip(true);
  };

  const closeBetSlip = () => setShowBetSlip(false);
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );
      if (response?.data?.status !== undefined) {
        const messageObj = {
          status: !!response.data.status,
          message: response.data.message
        };
        if (response.data.status) {
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        }
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      const err = error?.response?.data;
      if (err?.status === false) {
        setBetErrorMessage({ status: false, message: err.message });
      }
    }
  };

  const getPayloadRunnerName = (index, fallback) => {
    if (!payload) return fallback;
    return payload[`rnr${index}`] || payload[`cat_rnr${index}`] || fallback;
  };

  const displayRunnerName = (runnerName, runnerSid) => {
    const sid =
      runnerSid !== undefined && runnerSid !== null && runnerSid !== ""
        ? String(runnerSid)
        : "";
    if (sid === "1") return getPayloadRunnerName(1, "Team 1");
    if (sid === "2") return getPayloadRunnerName(2, "Team 2");
    if (sid === "3") return getPayloadRunnerName(3, "Wicket");
    if (sid === "4") return getPayloadRunnerName(4, "No Winner");
    if (sid === "5") return getPayloadRunnerName(5, "Boundary");
    if (sid === "6") return getPayloadRunnerName(6, "No Winner");

    const key = String(runnerName || "").toLowerCase();
    if (key === "b1" || key === "l1" || key === "player a")
      return getPayloadRunnerName(1, "Team 1");
    if (key === "b2" || key === "l2" || key === "player b")
      return getPayloadRunnerName(2, "Team 2");
    if (key === "b3" || key === "l3") return getPayloadRunnerName(3, "Wicket");
    if (key === "b4") return getPayloadRunnerName(4, "No Winner");
    if (key === "b5") return getPayloadRunnerName(5, "Boundary");
    if (key === "b6") return getPayloadRunnerName(6, "No Winner");
    return runnerName;
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 === 2) {
      showResultDetail();
    }
  };

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "superover_t20_virtual";

    //console.log("BEFORE API CALL");

    const response = await axiosInstance.post("/teenpatti-results", resultObj);
    //console.log("FULL RESPONSE", response.data);
    //console.log("FIRST RESULT", response.data.results_list[0]);
    //console.log("AFTER API CALL");

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };

  const fetchProfile = async () => {
    try {
      const { data: profile } = await axiosInstance.get("/profile");
      setProfileData(profile);
    } catch (error) {
      //console.log("Failed to load profile:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "superover_t20_virtual"
    });
    setPlacedBets(res.data || []);
  }

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "superover_t20_virtual"
    });
    const books = res?.data || [];
    books.forEach((obj) => {
      if (obj.Type === "main") {
        setTeamABook(obj.PlayerA ?? obj.Afghanistan ?? 0);
        setTeamBBook(obj.PlayerB ?? obj.SouthAfrica ?? 0);
        return;
      }

      if (obj.Type === "fancySid") {
        setWicketBook(isNaN(Number(obj.sid3)) ? 0 : Number(obj.sid3));
        setNoWicketBook(isNaN(Number(obj.sid4)) ? 0 : Number(obj.sid4));
        setBoundaryBook(isNaN(Number(obj.sid5)) ? 0 : Number(obj.sid5));
        setNoBoundaryBook(isNaN(Number(obj.sid6)) ? 0 : Number(obj.sid6));
        return;
      }

      if (obj.Type !== "fancy") return;

      const sid = String(obj.rnr_sid || "");
      const bookVal = obj.lay ?? obj.back ?? 0;
      if (sid === "3") setWicketBook(bookVal);
      else if (sid === "4") setNoWicketBook(bookVal);
      else if (sid === "5") setBoundaryBook(bookVal);
      else if (sid === "6") setNoBoundaryBook(bookVal);
    });

    applyBooksFromPayload();
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!payload?.cat_mid) return;
    getPlacedBets();
    getBook();
    if (!initialBetsFetched) setInitialBetsFetched(true);
  }, [payload?.cat_mid]);

  const getCardImage = (cardValue) => {
    if (!cardValue || cardValue === "NOT AVAILABLE") return "1";
    const code = String(cardValue).trim();
    return code && code !== "1" ? code : "1";
  };

  const teamAName = getPayloadRunnerName(1, payload?.team1 || "Team 1");
  const teamBName = getPayloadRunnerName(2, payload?.team2 || "Team 2");
  const wicketName = getPayloadRunnerName(3, "Wicket");
  const noWicketName = getPayloadRunnerName(4, "No Winner");
  const boundaryName = getPayloadRunnerName(5, "Boundary");
  const noBoundaryName = getPayloadRunnerName(6, "No Winner");
  const teamABalls = getTeamBallRuns(payload, "a", revealCountA);
  const teamBBalls = getTeamBallRuns(payload, "b", revealCountB);
  const teamAScore = sumBallRuns(teamABalls);
  const teamBScore = sumBallRuns(teamBBalls);
  const teamACardsAll = getTeamCards(payload, "a");
  const teamBCardsAll = getTeamCards(payload, "b");
  const teamACards = teamACardsAll.slice(0, revealCountA);
  const teamBCards = teamBCardsAll.slice(0, revealCountB);

  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const renderBall = (run, key) => (
    <div key={key} className="so-t20-ball-chip">
      <img src={ball} alt="" className="so-t20-ball-chip-img" />
      <span className="so-t20-ball-chip-val">{run}</span>
    </div>
  );

  const renderRunner = (
    label,
    book,
    win,
    backPrice,
    layPrice,
    marketType,
    sid,
    key,
    backendRunnerName
  ) => (
    <div className="runner-runner" style={{ height: "auto" }} key={key}>
      <h3 className={win ? "runner-name sussesBg" : "runner-name"}>
        <div className="runner-info">
          <span className="clippable runner-display-name">
            <table>
              <tbody>
                <tr>
                  <td>
                    <h4
                      style={{
                        marginBottom: 0,
                        fontWeight: "bold",
                        fontSize: "16px"
                      }}
                      className="clippable-spacer"
                    >
                      {label}
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div
                      style={{
                        float: "left",
                        display: book !== 0 ? "" : "none",
                        color: book > 0 ? "green" : "red",
                        fontWeight: 600
                      }}
                    >
                      {formatTruncate(book)}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </span>
        </div>
      </h3>
      <div className="price-row-box-new">
        {isSuspended && (
          <div className="runner-disabled2 suspendCls">{suspendedText}</div>
        )}
        <a
          className="price-price price-back whtBack"
          style={{ backgroundColor: "#dbeff8" }}
        >
          <div>&nbsp;</div>
        </a>
        <a
          className="price-price price-back whtBack"
          style={{ backgroundColor: "#dbeff8" }}
        >
          <div>&nbsp;</div>
        </a>
        <a
          className={
            backPrice > 0
              ? "price-price price-back mb-show span1details"
              : "price-price price-back mb-show"
          }
          style={
            backPrice > 0
              ? { backgroundColor: "#dbeff8", cursor: "pointer" }
              : {}
          }
          onClick={
            backPrice > 0
              ? () =>
                showBetfairBetSlip(
                  "b",
                  backendRunnerName,
                  backendRunnerName,
                  backPrice,
                  marketType,
                  sid
                )
              : undefined
          }
        >
          {backPrice > 0 ? (
            <>
              {backPrice}
              <span className="price-amount">{stakeLimit}</span>
            </>
          ) : (
            <div>&nbsp;</div>
          )}
        </a>
        {layPrice > 0 ? (
          <a
            className="price-price price-lay ml-4 mb-show span1details"
            style={{ backgroundColor: "#fce6e6", cursor: "pointer" }}
            onClick={() =>
              showBetfairBetSlip(
                "l",
                backendRunnerName,
                backendRunnerName,
                layPrice,
                marketType,
                sid
              )
            }
          >
            {layPrice}
            <span className="price-amount">{stakeLimit}</span>
          </a>
        ) : (
          <a
            className="price-price price-lay ml-4 mb-show"
            style={{ backgroundColor: "#fce6e6" }}
          >
            <div>&nbsp;</div>
          </a>
        )}
        <a
          className="price-price price-lay whtBack"
          style={{ backgroundColor: "#fce6e6" }}
        >
          <div>&nbsp;</div>
        </a>
        <a
          className="price-price price-lay mr-4 whtBack"
          style={{ backgroundColor: "#fce6e6" }}
        >
          <div>&nbsp;</div>
        </a>
      </div>
    </div>
  );

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  //console.log("resultList:", resultList);

  return (
    <div className="superover-t20-scope aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div className="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                          <div className="col-6 col-md-6 titlebarname inline-block Gameidcol mt-2">
                            <p>SUPER OVER T20</p>
                          </div>
                          <div
                            className="col-6 col-md-6 inline-block Gameidcol text-right"
                            style={{ marginTop: "4px" }}
                          >
                            <div className="btn-group btn-group-sm mr-2">
                              <button
                                type="button"
                                className={
                                  activeTabIndex === 1
                                    ? "tablink btn btn-primary bbactive"
                                    : "tablink btn btn-primary"
                                }
                                onClick={() => activeTab(1)}
                              >
                                Game
                              </button>
                              <button
                                type="button"
                                className={
                                  activeTabIndex === 2
                                    ? "tablink btn btn-primary bbactive"
                                    : "tablink btn btn-primary"
                                }
                                onClick={() => activeTab(2)}
                              >
                                Results
                              </button>
                              <button
                                type="button"
                                className="tablink btn btn-primary"
                                onClick={() => setShowRules(true)}
                              >
                                Rules
                              </button>
                            </div>
                          </div>
                        </div>

                        <div
                          className="cards-layout blackjack so-t20-board"
                          style={{
                            display: activeTabIndex === 1 ? "" : "none"
                          }}
                        >
                          <div
                            id="videos"
                            className="so-t20-videos collapse show"
                          >
                            <div className="row timerDiv2 so-t20-score-bar mx-0">
                              <div
                                className="col-auto so-t20-score-col"
                                style={{ padding: "0px 1px" }}
                              >
                                <div className="player-item so-t20-score-item">
                                  <div className="player-card so-t20-score-card">
                                    <div
                                      className="SOODSC"
                                      style={{
                                        borderBottom: "1px solid",
                                        paddingTop: "5px"
                                      }}
                                    >
                                      <b>
                                        {teamAName} : {teamAScore}
                                      </b>
                                    </div>
                                    <div
                                      className="SOODSC"
                                      style={{ paddingTop: "5px" }}
                                    >
                                      <b>
                                        {teamBName} : {teamBScore}
                                      </b>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="col-auto so-t20-balls-col"
                                style={{ padding: "0px" }}
                              >
                                <div className="player-item so-t20-score-item">
                                  <div className="player-card so-t20-balls-card">
                                    <div
                                      className="balldiv"
                                      style={{ borderBottom: "1px solid" }}
                                    >
                                      {teamABalls.map((run, idx) =>
                                        renderBall(run, `ba-${idx}`)
                                      )}
                                    </div>
                                    <div className="balldiv">
                                      {teamBBalls.map((run, idx) =>
                                        renderBall(run, `bb-${idx}`)
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col so-t20-timer-col px-0">
                                <div className="base-timer so-t20-base-timer">
                                  <svg
                                    viewBox="0 0 100 100"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="base-timer__svg"
                                  >
                                    <g className="base-timer__circle">
                                      <circle
                                        cx="50"
                                        cy="50"
                                        r="45"
                                        className="base-timer__path-elapsed"
                                      />
                                      <path
                                        strokeDasharray={`${Math.round(
                                          dash
                                        )} ${Math.round(CIRC)}`}
                                        className={`base-timer__path-remaining ${timerColor}`}
                                        d="
                                          M 50, 50
                                          m -45, 0
                                          a 45,45 0 1,0 90,0
                                          a 45,45 0 1,0 -90,0
                                        "
                                      />
                                    </g>
                                  </svg>
                                  <span className="base-timer__label">
                                    {timeLeft === 1 ? 0 : timeLeft}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="so-t20-teams">
                              <div className="so-t20-team-block">
                                <span className="so-t20-team-title">
                                  {teamAName}
                                </span>
                                <div className="so-t20-hand-panel">
                                  <div className="BFBCardFanViewab wrap_flex so-t20-cards">
                                    {teamACards.map((card, idx) => (
                                      <img
                                        key={`ca-${idx}-${card}`}
                                        src={`/assets/images/cards/${getCardImage(
                                          card
                                        )}.svg`}
                                        className="so-t20-card-img so-t20-card-reveal"
                                        draggable={false}
                                        style={{
                                          width: isMobile ? "46px" : "40px",
                                          height: isMobile ? "55px" : "55px"
                                        }}
                                      />
                                    ))}
                                  </div>
                                </div>
                              </div>

                              <div className="so-t20-team-block">
                                <span className="so-t20-team-title">
                                  {teamBName}
                                </span>
                                <div className="so-t20-hand-panel">
                                  <div className="BFBCardFanViewab wrap_flex so-t20-cards">
                                    {teamBCards.map((card, idx) => (
                                      <img
                                        key={`cb-${idx}-${card}`}
                                        src={`/assets/images/cards/${getCardImage(
                                          card
                                        )}.svg`}
                                        className="so-t20-card-img so-t20-card-reveal"
                                        draggable={false}
                                        style={{
                                          width: isMobile ? "46px" : "40px",
                                          height: isMobile ? "55px" : "55px"
                                        }}
                                      />
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="so-t20-volume-row">
                              <div className="Connectedclients mt-1">
                                <i
                                  aria-hidden="true"
                                  className="fa fa-user mr-1"
                                  style={{ fontSize: "14px", color: "white" }}
                                />
                                <b>
                                  <span className="number">326</span>
                                </b>
                              </div>
                              <div className="volume-wrapper">
                                <Volume />
                              </div>
                            </div>
                          </div>
                        </div>
                        <center
                          style={{
                            display: activeTabIndex === 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList).map((idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {resultList[idx]}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </center>

                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex === 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content so-t20-market-board"
                            style={{ background: "#fff" }}
                          >
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MATCH ODDS </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span />
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div className="market-runners">
                              {renderRunner(
                                teamAName,
                                teamABook,
                                winnerA && cardsSettled,
                                b1Val,
                                l1Val,
                                "m",
                                1,
                                "m1",
                                teamAName
                              )}
                              {renderRunner(
                                teamBName,
                                teamBBook,
                                winnerB && cardsSettled,
                                b2Val,
                                l2Val,
                                "m",
                                2,
                                "m2",
                                teamBName
                              )}
                            </div>
                          </div>
                        </div>

                        <div style={{ height: "5px" }}></div>

                        <div
                          className="bg-white so-t20-market-board"
                          style={{
                            display: activeTabIndex === 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                  />
                                </i>
                                <span>COMMON WICKET </span>
                              </span>
                            </p>
                            <div className="market-overarround">
                              <span />
                              <strong>Back</strong>
                            </div>
                            <div className="market-overarround market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>
                          <div className="market-runners">
                            {renderRunner(
                              wicketName,
                              wicketBook,
                              wicketWinner && cardsSettled,
                              b3Val,
                              l3Val,
                              "f",
                              3,
                              "w1",
                              wicketName
                            )}

                            {renderRunner(
                              noWicketName,
                              noWicketBook,
                              noWicketWinner && cardsSettled,
                              b4Val,
                              l4Val,
                              "f",
                              4,
                              "w2",
                              noWicketName
                            )}
                          </div>
                        </div>

                        <div style={{ height: "5px" }}></div>

                        <div
                          className="bg-white so-t20-market-board"
                          style={{
                            display: activeTabIndex === 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                  />
                                </i>
                                <span>COMMON BOUNDARY </span>
                              </span>
                            </p>
                            <div className="market-overarround">
                              <span />
                              <strong>Back</strong>
                            </div>
                            <div className="market-overarround market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>
                          <div className="market-runners">
                            {renderRunner(
                              boundaryName,
                              boundaryBook,
                              boundaryWinner && cardsSettled,
                              b5Val,
                              l5Val,
                              "f",
                              5,
                              "b1",
                              boundaryName
                            )}

                            {renderRunner(
                              noBoundaryName,
                              noBoundaryBook,
                              noBoundaryWinner && cardsSettled,
                              b6Val,
                              l6Val,
                              "f",
                              6,
                              "b2",
                              noBoundaryName
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: activeTabIndex == 2 ? "" : "none",
                            color: "white"
                          }}
                        >
                          <SuperOverT20Result resultData={resultData} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}

                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      />

                      <div className="bets">
                        <strong>
                          Matched Bets ({placedBets.length})
                          <img
                            src={reconnecting}
                            alt="dc"
                            className="rounded disconnected"
                            style={{ display: "none" }}
                          />
                        </strong>
                        <div className="betting-table">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Runner</th>
                                <th>Price</th>
                                <th>Size</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {placedBets.map((bet, index) => {
                                console.log("MATCHED BET:", bet);

                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      background:
                                        bet.type == "b"
                                          ? "#e9f6fc"
                                          : "#fce3e4"
                                    }}
                                  >
                                    <td>
                                      {displayRunnerName(bet.rnr)} - ({bet.cat_mid})
                                    </td>

                                    <td>{bet.amnt}</td>
                                    <td>{bet.rate}</td>
                                    <td></td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SuperT20Rules show={showRules} onClose={() => setShowRules(false)} />
        </div>

        <style>
          {`
                            

                            .superover-t20-scope .home-content {
                              margin-top: 0 !important;
                            }

                            .superover-t20-scope.player-scope img {
                              border-radius: 0;
                              overflow: visible;
                            }

                            .superover-t20-scope .so-t20-card-img,
                            .superover-t20-scope .so-t20-card-img.so-t20-card-reveal {
                              border-radius: 2px !important;
                              overflow: hidden;
                            }

                            .superover-t20-scope .cards-layout.blackjack {
                              position: relative;
                              background: #000 !important;
                            }

                            .superover-t20-scope .cards-layout.blackjack::before {
                              content: "";
                              position: absolute;
                              top: 0;
                              right: 0;
                              bottom: 0;
                              left: 0;
                              background: radial-gradient(
                                ellipse 100% 44% at 50% calc(30% + 70px),
                                rgba(62, 193, 65, 0.95) 0%,
                                rgba(62, 193, 65, 0.8) 15%,
                                rgba(30, 80, 35, 0.5) 40%,
                                #1e1e1e 55%,
                                #1e1e1e 100%
                              );
                              opacity: 0.4;
                              pointer-events: none;
                              z-index: 0;
                            }

                            .superover-t20-scope .cards-layout.blackjack > * {
                              position: relative;
                              z-index: 1;
                            }

                            .superover-t20-scope .so-t20-videos {
                              background: transparent !important;
                              padding-top: 10px !important;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2.so-t20-score-bar {
                              display: flex !important;
                              flex-wrap: nowrap !important;
                              align-items: stretch !important;
                              gap: 4px;
                              overflow-x: auto;
                              overflow-y: hidden;
                              padding-right: 10px !important;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-col,
                            .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-balls-col {
                              flex: 0 0 auto !important;
                              min-width: 0 !important;
                              max-width: none !important;
                              width: auto !important;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-timer-col {
                              flex: 1 1 auto !important;
                              min-width: 50px !important;
                              max-width: none !important;
                              margin-left: auto !important;
                              display: flex !important;
                              justify-content: flex-end !important;
                              align-items: center !important;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-item {
                              width: auto;
                              min-width: 0;
                            }

                            .superover-t20-scope .so-t20-teams {
                              margin-top: 20px;
                              padding-left: 0 !important;
                            }

                            .superover-t20-scope .player-card,
                            .superover-t20-scope .so-t20-score-card,
                            .superover-t20-scope .so-t20-balls-card,
                            .superover-t20-scope .so-t20-hand-panel {
                              background: transparent !important;
                              backdrop-filter: none;
                            }

                            .superover-t20-scope .so-t20-hand-panel {
                              padding: 5px 10px 6px;
                            }

                            .superover-t20-scope .so-t20-hand-panel .so-t20-cards {
                              min-height: 46px;
                            }

                            .superover-t20-scope .so-t20-hand-panel .so-t20-card-img {
                              width: 30px;
                            }

                            .superover-t20-scope .so-t20-score-card,
                            .superover-t20-scope .so-t20-balls-card {
                              display: flex !important;
                              flex-direction: column !important;
                            }

                            .superover-t20-scope .so-t20-score-card .SOODSC,
                            .superover-t20-scope .so-t20-balls-card .balldiv {
                              flex: 1 1 0;
                              height: 22px !important;
                              min-height: 22px !important;
                              max-height: 22px !important;
                              line-height: 22px !important;
                              padding-top: 0 !important;
                              box-sizing: border-box;
                              min-width: 0;
                              overflow: hidden;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .SOODSC {
                              font-size: 10px !important;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-card,
                            .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-balls-card {
                              min-height: 51px !important;
                              overflow: hidden;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-card {
                              padding-top: 0 !important;
                              padding-bottom: 0 !important;
                              padding-left: 0 !important;
                              padding-right: 0 !important;
                              width: 175px !important;
                              min-width: 175px !important;
                              max-width: 175px !important;
                              flex: 0 0 175px !important;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-balls-card {
                              padding-left: 0 !important;
                              padding-right: 0 !important;
                              width: 325px !important;
                              min-width: 325px !important;
                              max-width: 325px !important;
                              flex: 0 0 325px !important;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .SOODSC b {
                              display: block;
                              max-width: 100%;
                              overflow: visible;
                              text-overflow: unset;
                              white-space: nowrap;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .balldiv {
                              overflow-x: auto;
                              overflow-y: hidden;
                              -webkit-overflow-scrolling: touch;
                              scrollbar-width: none;
                            }

                            .superover-t20-scope .so-t20-board .timerDiv2 .balldiv::-webkit-scrollbar {
                              display: none;
                            }

                            .superover-t20-scope .so-t20-balls-card .so-t20-ball-chip,
                            .superover-t20-scope .so-t20-balls-card .so-t20-ball-chip-img {
                              width: 21px;
                              height: 21px;
                            }

                            .superover-t20-scope .so-t20-team-title {
                              font-size: 12px !important;
                            }

                            .superover-t20-scope .so-t20-volume-row {
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              padding: 4px 12px 8px;
                              margin-top: 2px;
                            }

                            .superover-t20-scope .so-t20-volume-row .Connectedclients {
                              position: relative;
                              top: 0;
                              margin: 0;
                            }

                            .superover-t20-scope .so-t20-volume-row .volume-wrapper {
                              position: relative;
                              z-index: 1001;
                              margin: 0;
                              text-align: right;
                            }

                            .superover-t20-scope .so-t20-volume-row .volume-wrapper .sound-icon {
                              position: relative;
                              top: auto;
                              right: auto;
                              left: auto;
                              transform: scale(0.8);
                              transform-origin: center;
                            }

                            .so-t20-board {
                              width: 100%;
                              max-width: 100%;
                              min-height: 280px;
                              position: relative;
                              box-sizing: border-box;
                            }
                            .so-t20-videos {
                              width: 100%;
                              max-width: 100%;
                              text-align: center;
                              padding: 0;
                              border: solid 1px #130a21;
                              min-height: 280px;
                              position: relative;
                              background: #000;
                              overflow: hidden;
                              box-sizing: border-box;
                            }
                            .so-t20-board .timerDiv2.so-t20-score-bar {
                              z-index: 1;
                              text-align: left;
                              align-self: auto;
                              width: 100%;
                              max-width: 100%;
                              margin-left: 0;
                              margin-right: 0;
                              padding-top: 2px;
                            }
                            .so-t20-board .timerDiv2.row {
                              flex-wrap: nowrap;
                              align-items: stretch;
                            }
                            .so-t20-board .timerDiv2 .so-t20-score-col,
                            .so-t20-board .timerDiv2 .so-t20-balls-col {
                              flex: 0 0 auto;
                              width: auto;
                              max-width: none;
                              position: relative;
                              display: flex;
                              align-items: stretch;
                            }
                            .so-t20-board .timerDiv2 .so-t20-score-item {
                              display: flex;
                              position: static;
                              width: 100%;
                              margin: 0;
                            }
                            .so-t20-board .timerDiv2 .so-t20-score-card,
                            .so-t20-board .timerDiv2 .so-t20-balls-card {
                              width: 250px !important;
                              min-width: 250px !important;
                              max-width: 250px !important;
                              min-height: 64px !important;
                              height: 100% !important;
                              padding: 8px 12px !important;
                              border-radius: 20px !important;
                              border: 1px solid rgba(173, 172, 172, 0.5) !important;
                              display: flex !important;
                              flex-direction: column;
                              justify-content: center;
                              position: static;
                              box-sizing: border-box;
                              flex: 0 0 250px;
                              background: transparent !important;
                            }
                            .so-t20-board .timerDiv2 .so-t20-timer-col {
                              display: flex;
                              justify-content: flex-end;
                              align-items: center;
                              flex: 1 1 auto;
                              min-width: 0;
                              max-width: 100%;
                              padding-right: 4px !important;
                              position: relative;
                            }
                            .so-t20-board .timerDiv2 .so-t20-base-timer.base-timer {
                              position: relative !important;
                              top: auto !important;
                              left: auto !important;
                              width: 50px !important;
                              height: 50px !important;
                              flex-shrink: 0;
                            }
                            .so-t20-board .timerDiv2 .so-t20-base-timer .base-timer__svg {
                              width: 100%;
                              height: 100%;
                              display: block;
                            }
                            .so-t20-board .timerDiv2 .so-t20-base-timer .base-timer__label {
                              position: absolute !important;
                              top: 50% !important;
                              left: 50% !important;
                              transform: translate(-50%, -50%) !important;
                              width: 100% !important;
                              height: 100% !important;
                              margin: 0 !important;
                              padding: 0 !important;
                              display: flex !important;
                              align-items: center !important;
                              justify-content: center !important;
                              font-size: 18px !important;
                              line-height: 1 !important;
                              color: #fff !important;
                            }
                            .so-t20-board .timerDiv2 .SOODSC {
                              height: 28px !important;
                              min-height: 28px !important;
                              line-height: 28px !important;
                              font-size: 16px !important;
                              color: #d7bc7b !important;
                              text-align: center !important;
                              display: flex !important;
                              align-items: center !important;
                              justify-content: center !important;
                            }
                            .so-t20-board .timerDiv2 .balldiv {
                              display: flex;
                              flex-wrap: nowrap;
                              gap: 3px;
                              min-height: 28px !important;
                              height: 28px;
                              align-items: center;
                              justify-content: center;
                            }
                            .so-t20-ball-chip {
                              position: relative;
                              display: inline-flex;
                              align-items: center;
                              justify-content: center;
                              width: 26px;
                              height: 26px;
                              flex-shrink: 0;
                            }
                            .so-t20-ball-chip-img {
                              width: 26px;
                              height: 26px;
                              display: block;
                            }
                            .so-t20-ball-chip-val {
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -52%);
                              color: #fff;
                              font-size: 11px;
                              font-weight: 700;
                              line-height: 1;
                              pointer-events: none;
                            }
                            .so-t20-teams {
                              width: 100%;
                              max-width: 100%;
                              padding: 4px 8px 0;
                              box-sizing: border-box;
                            }
                            .so-t20-team-block {
                              width: 100%;
                              max-width: 100%;
                              margin-bottom: 10px;
                              box-sizing: border-box;
                            }
                            .so-t20-team-title {
                              display: block;
                              color: #d7bc7b;
                              font-size: 14px;
                              font-weight: 700;
                              text-align: center;
                              margin-bottom: 6px;
                              text-transform: uppercase;
                            }
                            .so-t20-hand-panel {
                              width: 100% !important;
                              max-width: 100% !important;
                              margin: 0;
                              border: 1px solid rgba(173, 172, 172, 0.5);
                              border-radius: 15px;
                              padding: 8px 10px 10px;
                              box-sizing: border-box;
                              background: transparent;
                            }
                            .so-t20-cards {
                              width: 100% !important;
                              max-width: 100% !important;
                              justify-content: center !important;
                              align-items: center;
                              min-height: 72px;
                              gap: 4px;
                              box-sizing: border-box;
                            }
                            .so-t20-card-img {
                              width: 46px;
                              height: auto;
                              display: block;
                              border-radius: 2px;
                              flex-shrink: 0;
                            }
                            @keyframes so-t20-card-in {
                              from {
                                opacity: 0;
                                transform: scale(0.85);
                              }
                              to {
                                opacity: 1;
                                transform: scale(1);
                              }
                            }
                            .so-t20-card-reveal {
                              animation: so-t20-card-in 0.35s ease-out;
                            }
                            /* ── Suspended / Next Round overlay ── */
                            .so-t20-board .price-row-box-new {
                              position: relative;
                            }
                            .so-t20-board .runner-disabled2 {
                              position: absolute;
                              top: 0; left: 0; right: 0; bottom: 0;
                              width: auto;
                              height: auto;
                              line-height: normal;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              background: rgba(236, 236, 237, 0.92);
                              color: #f00;
                              font-weight: 700;
                              font-size: 13px;
                              text-transform: uppercase;
                              z-index: 10;
                              border-radius: 4px;
                            }
                            @media (max-width: 767.98px) {
                              .so-t20-board,
                              .so-t20-videos {
                                min-height: 200px !important;
                              }
                              .so-t20-board .timerDiv2.so-t20-score-bar {
                                display: flex !important;
                                flex-wrap: nowrap !important;
                                align-items: stretch !important;
                                width: 100% !important;
                                overflow: hidden;
                              }
                              .so-t20-board .timerDiv2 .so-t20-score-col {
                                flex: 0 0 120px !important;
                                min-width: 0 !important;
                                max-width: 120px !important;
                                width: 120px !important;
                                padding: 0 2px !important;
                              }
                              .so-t20-board .timerDiv2 .so-t20-balls-col {
                                flex: 1 1 0 !important;
                                min-width: 0 !important;
                                max-width: none !important;
                                width: auto !important;
                                padding: 0 2px !important;
                              }
                              .so-t20-board .timerDiv2 .so-t20-timer-col {
                                flex: 0 0 54px !important;
                                min-width: 54px !important;
                                max-width: 54px !important;
                                width: 54px !important;
                                padding-right: 2px !important;
                              }
                              .so-t20-board .timerDiv2 .so-t20-score-card {
                                width: 100% !important;
                                min-width: 0 !important;
                                max-width: 120px !important;
                                flex: 0 0 auto !important;
                                padding: 8px 6px !important;
                                min-height: 64px !important;
                                border-radius: 20px !important;
                              }
                              .so-t20-board .timerDiv2 .so-t20-balls-card,
                              .so-t20-board .timerDiv2 .player-card.so-t20-balls-card {
                                width: 100% !important;
                                min-width: 220px !important;
                                max-width: none !important;
                                flex: 1 1 auto !important;
                                padding: 8px 4px !important;
                                min-height: 64px !important;
                                border-radius: 20px !important;
                              }
                              .so-t20-board .timerDiv2 .SOODSC {
                                font-size: 14px !important;
                                height: 28px !important;
                                min-height: 28px !important;
                                line-height: 28px !important;
                              }
                              .so-t20-board .timerDiv2 .SOODSC b {
                                display: block;
                                max-width: 100%;
                                overflow: visible;
                                text-overflow: unset;
                                white-space: nowrap;
                                font-size: inherit;
                              }
                              .so-t20-board .timerDiv2 .balldiv {
                                min-height: 28px !important;
                                height: 28px;
                                gap: 2px;
                                overflow-x: auto;
                                overflow-y: hidden;
                                -webkit-overflow-scrolling: touch;
                                scrollbar-width: none;
                              }
                              .so-t20-board .timerDiv2 .balldiv::-webkit-scrollbar {
                                display: none;
                              }
                              .so-t20-ball-chip {
                                width: 22px;
                                height: 22px;
                              }
                              .so-t20-ball-chip-img {
                                width: 22px;
                                height: 22px;
                              }
                              .so-t20-ball-chip-val {
                                font-size: 10px;
                              }
                              .so-t20-board .timerDiv2 .so-t20-base-timer.base-timer {
                                width: 54px !important;
                                height: 54px !important;
                              }
                              .so-t20-board .timerDiv2 .so-t20-base-timer .base-timer__label {
                                font-size: 18px !important;
                              }
                              .so-t20-card-img {
                                width: 36px;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2.so-t20-score-bar {
                                overflow: hidden;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-col {
                                flex: 0 0 120px !important;
                                width: 120px !important;
                                max-width: 120px !important;
                                min-width: 0 !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-balls-col {
                                flex: 1 1 0 !important;
                                min-width: 0 !important;
                                width: auto !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-timer-col {
                                flex: 0 0 54px !important;
                                min-width: 54px !important;
                                max-width: 54px !important;
                                margin-left: 0 !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-base-timer.base-timer {
                                width: 54px !important;
                                height: 54px !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-base-timer .base-timer__label {
                                font-size: 18px !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-item {
                                width: 100% !important;
                                min-width: 0;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-card {
                                width: 100% !important;
                                max-width: 120px !important;
                                min-width: 0 !important;
                                flex: 0 0 auto !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-balls-card,
                              .superover-t20-scope .so-t20-board .timerDiv2 .player-card.so-t20-balls-card {
                                width: 100% !important;
                                min-width: 220px !important;
                                max-width: none !important;
                                flex: 1 1 auto !important;
                              }
                              .superover-t20-scope .so-t20-score-card .SOODSC {
                                width: 100% !important;
                                max-width: 100% !important;
                                box-sizing: border-box;
                              }
                              .superover-t20-scope .so-t20-score-card .SOODSC:first-child {
                                border-bottom: 1px solid !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .SOODSC b {
                                width: auto !important;
                                max-width: 100% !important;
                                overflow: hidden !important;
                                text-overflow: ellipsis !important;
                                white-space: nowrap !important;
                              }
                              .superover-t20-scope .so-t20-score-card .SOODSC,
                              .superover-t20-scope .so-t20-balls-card .balldiv {
                                height: 28px !important;
                                min-height: 28px !important;
                                max-height: 28px !important;
                                line-height: 28px !important;
                                overflow: visible !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .SOODSC {
                                font-size: 14px !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-card,
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-balls-card {
                                min-height: 64px !important;
                                border-radius: 20px !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-score-card {
                                padding: 8px 6px !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .so-t20-balls-card {
                                padding: 8px 4px !important;
                              }
                              .superover-t20-scope .so-t20-board .timerDiv2 .balldiv {
                                gap: 2px !important;
                              }
                              .superover-t20-scope .so-t20-balls-card .so-t20-ball-chip,
                              .superover-t20-scope .so-t20-balls-card .so-t20-ball-chip-img {
                                width: 22px !important;
                                height: 22px !important;
                              }
                              .superover-t20-scope .so-t20-balls-card .so-t20-ball-chip-val {
                                font-size: 10px !important;
                              }
                              .superover-t20-scope .so-t20-team-title {
                                font-size: 9px !important;
                              }
                              .superover-t20-scope .left-content,
                              .superover-t20-scope .so-t20-market-board {
                                width: 100%;
                                padding-left: 0 !important;
                                padding-right: 0 !important;
                                box-sizing: border-box;
                              }
                              .superover-t20-scope .so-t20-market-board .market-titlebar {
                                display: grid !important;
                                grid-template-columns: minmax(0, 1fr) 64px 64px;
                                column-gap: 2px;
                                align-items: end;
                                width: 100%;
                                height: auto;
                                min-height: 24px;
                              }
                              .superover-t20-scope .so-t20-market-board .market-titlebar .market-name {
                                grid-column: 1;
                                grid-row: 1;
                                min-width: 0;
                                flex: unset !important;
                              }
                              .superover-t20-scope .so-t20-market-board .market-titlebar .market-overarround {
                                grid-column: 2;
                                grid-row: 1;
                              }
                              .superover-t20-scope .so-t20-market-board .market-titlebar .market-overarround-lay {
                                grid-column: 3;
                                grid-row: 1;
                              }
                              .superover-t20-scope .so-t20-market-board .market-titlebar .market-overarround,
                              .superover-t20-scope .so-t20-market-board .market-titlebar .market-overarround-lay {
                                width: 64px !important;
                                min-width: 64px !important;
                                max-width: 64px !important;
                                margin: 0 !important;
                                text-align: center;
                                justify-content: center !important;
                              }
                              .superover-t20-scope .so-t20-market-board .market-titlebar .market-overarround span {
                                display: none !important;
                              }
                              .superover-t20-scope .so-t20-market-board .market-titlebar .market-overarround strong {
                                width: 100% !important;
                                font-size: 11px !important;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner {
                                display: grid !important;
                                grid-template-columns: minmax(0, 1fr) 64px 64px;
                                column-gap: 2px;
                                align-items: stretch;
                                width: 100%;
                                height: auto;
                                min-height: 50px;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .runner-name {
                                grid-column: 1;
                                grid-row: 1;
                                display: flex !important;
                                min-width: 0;
                                padding-left: 4px;
                                flex: unset !important;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .runner-info {
                                position: static !important;
                                left: auto !important;
                                top: auto !important;
                                height: auto !important;
                                max-width: 100% !important;
                                padding-top: 4px;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new {
                                grid-column: 2 / 4;
                                grid-row: 1;
                                display: grid !important;
                                grid-template-columns: 64px 64px;
                                column-gap: 2px;
                                position: relative;
                                width: 130px !important;
                                max-width: 130px !important;
                                min-width: 130px !important;
                                margin: 0 !important;
                                flex: unset !important;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new .price-price {
                                display: none !important;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new .price-price.mb-show {
                                display: flex !important;
                                align-items: center;
                                justify-content: center;
                                flex-direction: column;
                                width: 64px !important;
                                max-width: 64px !important;
                                min-width: 64px !important;
                                height: 50px !important;
                                flex: 0 0 64px !important;
                                margin: 0 !important;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new .price-price.price-back.mb-show {
                                grid-column: 1;
                                grid-row: 1;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new .price-price.price-lay.mb-show {
                                grid-column: 2;
                                grid-row: 1;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new .price-amount {
                                font-size: 10px;
                                line-height: 1.1;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new .price-price.ml-4,
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new .price-price.mr-4 {
                                margin-left: 0 !important;
                                margin-right: 0 !important;
                              }
                              .superover-t20-scope .so-t20-market-board .runner-runner .price-row-box-new .runner-disabled2 {
                                position: absolute;
                                inset: 0;
                                width: auto !important;
                                z-index: 2;
                              }
                            }
                          `}
        </style>
      </ClientLayoutWithOutHeader>
    </div>
  );
}
